/**
 * 根据搜索文本过滤列表项
 * @param items 要过滤的列表
 * @param searchText 搜索文本
 * @param getSearchFields 获取搜索字段的函数，返回要搜索的字符串数组
 * @returns 过滤后的列表
 */
export function filterBySearchText<T>(
  items: T[],
  searchText: string,
  getSearchFields: (item: T) => string[]
): T[] {
  if (!searchText) return items;
  
  const lower = searchText.toLowerCase();
  return items.filter(item => {
    const fields = getSearchFields(item);
    return fields.some(field => field.toLowerCase().includes(lower));
  });
}
